import SetRoute from '@src/services/setRoute';

const fetchPlatforms = (fetch, params = '') => ({
    payload: {
        dataset: 'platforms',
        action: 'get',
        route: SetRoute + `/api/v1/platforms${params}`,
        data: {},
    },
    fetch,
});

export {
    fetchPlatforms,
};
